module.exports = "/assets/QA_V3-13321bac06cc5eb342443ab22f627a7e.jpg";